"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retrocog = void 0;
var react_1 = __importStar(require("react"));
var Retrocog = function (_a) {
    var _b = _a.detachChildren, detachChildren = _b === void 0 ? false : _b, className = _a.className, style = _a.style, children = _a.children;
    var wrapperRef = (0, react_1.useRef)(null);
    var wrapperNodePatched = (0, react_1.useRef)(false);
    if (!detachChildren && wrapperNodePatched.current) {
        throw new Error("detachChildren was previously true but is now false");
    }
    if (detachChildren && !wrapperNodePatched.current) {
        if (!wrapperRef.current) {
            throw new Error("Couldn't get ref to snapshot-wrapper");
        }
        wrapperRef.current.removeChild = function (child) { return child; };
        wrapperNodePatched.current = true;
    }
    return (react_1.default.createElement("div", __assign({ key: "snapshot-wrapper", ref: wrapperRef, className: className, style: style }, (detachChildren ? {} : { children: children }))));
};
exports.Retrocog = Retrocog;
